import React from "react";

export interface InspectionDueBodyTemplateProps {
    nextInspectionDetails: {
        isScheduled?: boolean;
        status?: number | null;
        dateFrom?: Date | null;
        dateTo?: Date | null;
        inspectionDue?: Date | null;
    };
}

const vesselViewDateOnlyTemplate = (date: Date, overdueText: string) => {
    const formattedScheduledDate = date.toLocaleDateString("en-GB");
    const today = new Date();

    const showOverdue = date < today;

    return (
        <p
            className={
                showOverdue
                    ? "vesselView__labelText--danger"
                    : "vesselView__labelText"
            }
        >
            {`${formattedScheduledDate} ${showOverdue ? overdueText : ""}`}
        </p>
    );
};

export const vesselViewInspectionDueBodyTemplate = (
    getFriendlyInspectionStatusText: (status: number) => string,
    overdueText: string,
    details?: InspectionDueBodyTemplateProps
) => {
    if (!details) {
        return <></>;
    }

    if (
        !details.nextInspectionDetails.isScheduled &&
        details.nextInspectionDetails.inspectionDue
    ) {
        return vesselViewDateOnlyTemplate(
            details.nextInspectionDetails.inspectionDue,
            overdueText
        );
    }

    if (
        details.nextInspectionDetails.isScheduled &&
        details.nextInspectionDetails.dateFrom
    ) {
        let dateString = "";
        if (details.nextInspectionDetails.dateTo) {
            dateString = `${new Date(
                details.nextInspectionDetails.dateFrom
            ).toLocaleDateString("en-GB")} - ${new Date(
                details.nextInspectionDetails.dateTo
            ).toLocaleDateString("en-GB")}`;
        } else {
            dateString = new Date(
                details.nextInspectionDetails.dateFrom
            ).toLocaleDateString("en-GB");
        }

        return (
            <>
                <p className={"vesselView__labelText"}>{dateString}</p>
                <p className={"vesselView__labelText"}>
                    {details.nextInspectionDetails.status &&
                        getFriendlyInspectionStatusText(
                            details.nextInspectionDetails.status
                        )}
                </p>
            </>
        );
    }

    if (details.nextInspectionDetails.inspectionDue) {
        return vesselViewDateOnlyTemplate(
            details.nextInspectionDetails.inspectionDue,
            overdueText
        );
    }

    return <></>;
};
